import * as React from "react";
import {Form, Row, Col} from "react-bootstrap";


export default ({props}) => (
    <div> 
        <Form.Group>
            <Form.Label className="font-weight-bold">Project name</Form.Label>
            <Form.Control 
                type="text"
                placeholder="Project abc"
                name="projectName"
                value={props.values.projectName}
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                isInvalid={!!props.errors.projectName}
            />
            <Form.Control.Feedback type="invalid">
                <small>Please provide a name for your project</small>
            </Form.Control.Feedback>
        </Form.Group>

        <h5>Add project description</h5>
        <p>Bla bla bla</p>

        <Form.Group>
            <Form.Label className="font-weight-bold">Select project type</Form.Label>
            <Form.Control name="projectType" as="select" value={props.values.projectType} onChange={props.handleChange} onBlur={props.handleBlur}>
                <option>Choose...</option>
                <option>Something else</option>
            </Form.Control>
        </Form.Group>

        <Form.Group>
            <Form.Label className="font-weight-bold">Set project duration</Form.Label>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label className="text-muted">From</Form.Label>
                        <Form.Control 
                            type="Text"
                            name="startDate"
                            value={props.values.startDate}
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label className="text-muted">From</Form.Label>
                        <Form.Control 
                            type="Text"
                            name="endDate"
                            value={props.values.endDate}
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </Form.Group>   
    </div>
)